/**
 * Normalize API/user tenant id to a plain string (or null).
 * Handles ObjectId strings, populated `{ _id }`, and `{ id }` tenant objects.
 */
export const normalizeTenantId = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'object') {
    const id = value._id ?? value.id ?? null;
    return id == null || id === '' ? null : String(id);
  }
  return String(value);
};

export const resolveUserTenantId = (user) => {
  if (!user) return null;
  return (
    normalizeTenantId(user.tenantId) ||
    normalizeTenantId(user.tenant) ||
    null
  );
};
